import { isMemoizedFunction, cloneMemoizedFunction } from "./memoize";

export const clone = <T extends { [k: string]: any }, K extends keyof T>(x: T, o: Pick<T, K>): T => {
  const c = {} as T;

  // Copy all existing properties. Copy the descriptors and not the values!
  // This ensures that lazy properties are not forced.
  Object.getOwnPropertyNames(x).forEach((k) => {
    if (isMemoizedFunction(x, k)) {
      Object.defineProperty(c, k, { value: cloneMemoizedFunction(x[k]) });
    } else {
      Object.defineProperty(c, k, Object.getOwnPropertyDescriptor(x, k) as any);
    }
  });

  // Override properties
  Object.assign(c, o);

  return c;
};
